import React from 'react';
import ReactDOM from 'react-dom/client';
import Realindex from './Realindex';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Realindex />
  </React.StrictMode>
);
